import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { loginRedirectState } from '../../utils/returnPath';
import TermsAcceptance from '../TermsAcceptance/TermsAcceptance';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, termsStatus } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div className="mt-3">
            <p className="text-muted">Loading PropWise...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Login sends the user back here after sign-in (utils/returnPath).
    return <Navigate to="/login" replace state={loginRedirectState(location)} />;
  }

  // Task 05. Rendered INSTEAD of children, so no protected page mounts and
  // nothing is fetched behind the prompt. Sidebar does not render either;
  // TermsAcceptance carries its own Sign Out.
  if (termsStatus !== 'clear') {
    return <TermsAcceptance />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;